import { render } from "./TranslationEdit.vue?vue&type=template&id=4fb428ca&ts=true"
import script from "./TranslationEdit.vue?vue&type=script&lang=ts"
export * from "./TranslationEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__